import React from 'react';

class FourOhFourPage extends React.Component {
  render() {
    return 'Page not Found';
  }
}

export default FourOhFourPage;
